import { useMutation } from "@tanstack/react-query";

import { deleteAllGlobalScheduleRules } from "~/api/global-schedule-rules";
import { errorToast, toast } from "~/ui";

type UseDeleteAllGlobalScheduleRulesOptions = {
  onSuccess?: () => void;
};

export const useDeleteAllGlobalScheduleRules = (
  options?: UseDeleteAllGlobalScheduleRulesOptions,
) =>
  useMutation({
    mutationFn: deleteAllGlobalScheduleRules,
    onSuccess: () => {
      toast({ type: "success", title: "Global rules deleted successfully" });
      options?.onSuccess?.();
    },
    onError: errorToast,
  });
